import { Button, Heading, Modal, Text } from "@ttc3k/trekker";
import { Xmark } from "iconoir-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Flex } from "styled-system/jsx";
import { useWorkbenchSession } from "shared/contextProviders/workbenchSession";
import { WorkbenchChatPanel } from "./WorkbenchChatPanel";

/** The Workbench chat anywhere in the app while a test session is active. */
export const WorkbenchChatSlideout = () => {
  const navigate = useNavigate();
  const { session, isChatOpen, setChatOpen, setHasUnread, startWorkbenchSession, stopWorkbenchSession } =
    useWorkbenchSession();
  /** After "Finish review" the slideout stays open on the summary, so the tester can start a new chat or leave. */
  const [reviewFinished, setReviewFinished] = useState(false);

  const sessionChatId = session?.chatId;
  useEffect(() => setReviewFinished(false), [sessionChatId]);

  useEffect(() => {
    if (isChatOpen) setHasUnread(false);
  }, [isChatOpen, setHasUnread]);

  if (!session) return null;

  return (
    <Modal
      open={isChatOpen}
      placement="rightPane"
      onOpenChange={() => setChatOpen(false)}
      hideCloseTrigger
      portal
    >
      <Flex flexDir="column" h="100%" maxH="100%">
        <Flex
          px="300"
          py="200"
          borderBottomWidth="1px"
          borderColor="border.light"
          justifyContent="space-between"
          alignItems="center"
          flexShrink={0}
        >
          <Flex flexDir="column">
            <Heading size="h5">Whereabot · {session.featureName}</Heading>
            <Text visual="smallRegular" color="text.light">
              What you do in the app is attached to your next message.
            </Text>
          </Flex>
          <Flex gap="100" alignItems="center">
            {reviewFinished && (
              <Button
                size="sm"
                visual="primary"
                mode="light"
                width="auto"
                onClick={() => {
                  const returnTo = session.returnTo;
                  setReviewFinished(false);
                  stopWorkbenchSession();
                  navigate(returnTo);
                }}
              >
                Back to Workbench
              </Button>
            )}
            <Button
              size="sm"
              visual="primary"
              mode="light"
              width="auto"
              Icon={Xmark}
              aria-label="Close"
              onClick={() => setChatOpen(false)}
            />
          </Flex>
        </Flex>
        <Flex flex="1" minH="0">
          <WorkbenchChatPanel
            key={session.chatId}
            chatId={session.chatId}
            isVisible={isChatOpen}
            onReviewCompleted={() => setReviewFinished(true)}
            onNewChatStarted={newChatId => {
              setReviewFinished(false);
              startWorkbenchSession({ ...session, chatId: newChatId });
            }}
          />
        </Flex>
      </Flex>
    </Modal>
  );
};
